<template>
    <!-- 资质等级弹窗 -->
    <div class="aptitudeLevel" v-loading="loading" element-loading-text="加载中，请稍候" id="aptitudeLevel">
        <el-dialog title="资质等级" :visible="true" :before-close="closeDialog">
            <div><span style="width:25%;display:inline-block;font-weight:bold;">资质</span><span style="width:34%;display:inline-block;font-weight:bold;">等级</span><span style="width:25%;display:inline-block;font-weight:bold;">资质等级</span></div>
            <div class="main">
                <select multiple v-model="l_selection">
                    <option v-for="val in unitQualitys" :key="val.typecode" :value="val.typename">{{val.typename}}</option>
                </select>
                <select multiple v-model="l_selection2">
                    <option v-for="val in unitLevels" :key="val.typecode" :value="val.typename">{{val.typename}}</option>
                </select>
                <div class="btn-group-self">
                    <a href="javascript:" class="btn btn-default" :class="{light:l_selection.length>0&&l_selection2.length>0}" @click="raquo">&raquo;</a href="javascript:">
                    <a href="javascript:" style="margin-top:5px;" class="btn btn-default" :class="{light:r_selection.length>0}" @click="laquo">&laquo;</a href="javascript:">
                </div>
                <select multiple v-model="r_selection" style="width:35%;">
                    <option v-for="val in selection" :key="val" :value="val">{{val}}</option>
                </select>
            </div>
            <center slot="footer">
                <button class="btn btn-default" @click="returnSelection">确定</button>
                <button class="btn btn-default" @click="closeDialog"  style="margin-left:5px;" >取消</button>
            </center>
        </el-dialog>
    </div>
</template>
<script>
import { Dictionaries } from "@/resources.js"
export default {
    props: [],
    mounted() {
        this.queryAll();
    },
    data() {
        return {
            listData: [],
            selection: [],
            l_selection: [],
            l_selection2: [],
            r_selection: [],
            loading: true,
            unitQualitys: [],
            unitLevels: [],
        }
    },
    methods: {
        laquo() {
            // 删除选中
            for (let i in this.r_selection) {
                let index = this.search(this.selection, this.r_selection[i]);
                this.selection.splice(index, 1);
            }
        },
        raquo() {
            // 添加选中
            this.selection = [];
            for (let i in this.l_selection) {
                for(let k in this.l_selection2){
                    this.selection.push(this.l_selection[i]+this.l_selection2[k]);
                }
            }
        },
        queryAll() {
            this.loading = true;
            Dictionaries.query("listUnitQualityAndLevel", {}).then(res => {
                this.unitQualitys = res.unitQualitys;
                this.unitLevels = res.unitLevels;
                this.loading = false;
            })
        },
        returnSelection() {
            this.$emit("passSelection", this.selection)
            this.closeDialog();
        },
        closeDialog() {
            this.$emit("closeDialog")
        },
        search(arr, target) {
            let index = 0;
            for(index in arr){
                if(arr[index] === target){
                    break;
                }
            }
            return index;
            // let s = 0;
            // let e = arr.length - 1;
            // let m = Math.floor((s + e) / 2);
            // let sortTag = arr[s].id <= arr[e].id;//确定排序顺序

            // while (s < e && arr[m].id !== target) {
            //     if (arr[m].id > target) {
            //         sortTag && (e = m - 1);
            //         !sortTag && (s = m + 1);
            //     } else {
            //         !sortTag && (e = m - 1);
            //         sortTag && (s = m + 1);
            //     }
            //     m = Math.floor((s + e) / 2);
            // }
            // if (arr[m].id == target) {
            //     return m;
            // }
        }
    }
}
</script>
<style>
.aptitudeLevel .main {
    position: relative;
    overflow: hidden;
    height: 300px;
}

.aptitudeLevel select {
    width: 25%;
    float: left;
    height: 100%
}

.aptitudeLevel .btn-group-self {
    margin: 10% 2.5%;
    float: left
}

.aptitudeLevel .btn-group-self a {
    font-size: 14px;
    display: block;
    text-decoration: none;
}

.aptitudeLevel .light {
    color: #fff;
    background-color: #20a0ff;
    border-color: #20a0ff;
}
</style>


// WEBPACK FOOTER //
// aptitude_level.vue?4f1c6f29